// BookingFlows' own Meta Pixel — fires alongside (never instead of) any
// operator pixels. Uses trackSingle so events target ONLY this pixel.
export const BF_PIXEL_ID = '1879485989648740';

export const initBFPixel = () => {
  if (window.__bfPixelReady) return;
  try {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
      n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', BF_PIXEL_ID);
    window.__bfPixelReady = true;
  } catch { /* ad blockers — never break the app */ }
};

export const bfTrack = (event, params = {}, eventId) => {
  try {
    initBFPixel();
    if (!window.fbq) return;
    if (eventId) window.fbq('trackSingle', BF_PIXEL_ID, event, params, { eventID: eventId });
    else window.fbq('trackSingle', BF_PIXEL_ID, event, params);
  } catch { /* noop */ }
};

export const bfPageView = () => bfTrack('PageView');
